import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const AUTO_DEBIT_getNachStatus_API_CALL = createAsyncThunk(
  'AUTO_DEBIT_getNachStatus_API_CALL',
  async (payload, { dispatch }) => {
    dispatch({
      type: 'AUTO_DEBIT_getNachStatus_API_CALL/pending',
      payload: {},
    });
    const {
      getNachStatusAPIPaylod,
      successFn = () => {},
      errorFn = () => {},
      finallyFn = () => {},
    } = payload;
    const { customerId, customerRefNum, Authorization } =
      getNachStatusAPIPaylod;
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerkyc/getnachstatus',
      headers: {
        Authorization,
      },
      payload: {
        customerRefNum,
      },
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        // settingKycJourneyStatus(res);
        dispatch({
          type: 'AUTO_DEBIT_getNachStatus_API_CALL/fulfilled',
          payload: res,
        });
        successFn(res);
      },
      errorFn: (err) => {
        console.log(err);
        dispatch({
          type: 'AUTO_DEBIT_getNachStatus_API_CALL/rejected',
          payload: err,
        });
        errorFn(err);
      },
      finallyFn,
    });
  }
);

export const AUTO_DEBIT_getNachStatus_API_CALL_extrareducer = {
  [AUTO_DEBIT_getNachStatus_API_CALL.pending]: (state, action) => {
    state.getNachStatusAPICall.isLoading = true;
  },
  [AUTO_DEBIT_getNachStatus_API_CALL.fulfilled]: (state, action) => {
    state.getNachStatusAPICall.isLoading = false;
    state.getNachStatusAPICall.isSuccess = true;
    state.getNachStatusAPICall.isError = false;
    state.getNachStatusAPICall.response = action.payload;
  },
  [AUTO_DEBIT_getNachStatus_API_CALL.rejected]: (state, action) => {
    state.getNachStatusAPICall.isLoading = false;
    state.getNachStatusAPICall.isSuccess = false;
    state.getNachStatusAPICall.isError = true;
    state.getNachStatusAPICall.response = action.payload;
  },
};
